module.exports = __webpack_public_path__ + "static/media/foto_3.23f15b8e.png";